import { mapActions } from 'vuex'
import api from '../../api'
import roles from '../../helpers/userRoles'
import moment from 'moment'

import SideBar from '../../components/SideBar.vue'
import datepicker from '../../components/datepicker.vue'
import timepicker from '../../components/timepicker.vue'
import autocomplete from '../../components/autocoplete.vue'
import modal from '../../components/modal.vue'
import maskedInput from '../../components/masked-input.vue'

const mapClient = client => {
  return {
    id: client.id,
    leid: client.legal_entity ? client.legal_entity.id : null,
    name: client.name,
    email: client.email,
    phone: client.telephone,
    clientDescription: client.description
  }
}

const mapCompany = company => {
  return {
    id: company.id,
    name: company.name,
    address: company.address,
    email: company.email,
    phone: company.telephone,
    description: company.description
  }
}

export default {
  name: 'CreateTaskManualy',
  components: {
    datepicker,
    timepicker,
    autocomplete,
    modal,
    SideBar,
    'masked-input': maskedInput
  },
  props: {
    taskId: {
      default: null
    },
    isUpdate: {
      default: false
    },
    isFromCalculator: {
      default: false
    },
    checkedCardItems: {
      default: () => []
    }
  },
  data: () => {
    return {
      managerId: null,
      taskName: '',
      deadlineDate: null,
      deadlineTime: null,
      isHot: false,
      clientId: null,
      clientName: '',
      clientEmail: '',
      clientPhone: '',
      clientDescription: '',
      roles,
      users: [],
      savedClientSelected: false,
      clients: [],
      companies: [],
      companyId: null,
      companyName: '',
      companyEmail: '',
      companyPhone: '',
      savedCompanySelected: false,
      taskDescription: '',
      techMap: [],
      techMapDesc: '',
      totalCost: 0,
      needToShowModal: true,
      showModal: false,
      isActiveInfoMap: true,
      isActiveTechMap: false,
      isActivePrivate: true,
      isActiveCompany: false,
      selectedBasketItem: null,
      isAddFromBasketActive: false,
      isBlockSaveButton: false,
      autoExecution: false,
      autoAlert: false
    }
  },
  methods: {
    async loadUsers () {
      try {
        const resp = await api.get.users()
        this.users = resp.data.data.users.filter(x => x.enabled)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadClients () {
      try {
        const resp = await api.get.clients()
        this.clients = resp.data.data.clients.map(mapClient)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadCompanies () {
      try {
        const resp = await api.get.companies()
        this.companies = resp.data.data.legalEntities.map(mapCompany)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    createTask () {
      if (!this.taskName) {
        return
      }

      const taskInfo = {
        name: this.taskName,
        price: this.totalCost,
        description: this.taskDescription,
        end_time: this.deadLineDateTime,
        hot: this.isHot,
        manager: this.managerId,
        client_id: this.clientId,
        client_name: this.clientName || null,
        client_email: this.clientEmail,
        client_telephone: this.clientPhone,
        client_description: this.clientDescription,
        company_id: this.companyId,
        company_name: this.companyName || null,
        company_email: this.companyEmail,
        company_telephone: this.companyPhone,
        tech_map_desc: this.techMapDesc,
        auto_execution: this.autoExecution,
        auto_alert: this.autoAlert
      }

      if (this.techMap.length > 0) {
        taskInfo.tech_map = this.techMap.map(x => x.id)
      } else {
        taskInfo.tech_map = null
      }

      this.isBlockSaveButton = true

      if (this.isUpdate) {
        api.post
          .updateTask(this.taskId, taskInfo)
          .then(resp => {
            this.needToShowModal = false
            const createdTaskId = resp.data.data.task.id
            this.updateTask(createdTaskId).then(() => {
              this.$router.push(`/view-task/${createdTaskId}`)
              // this.$router.push(`/`)
            })
          })
          .catch(() => {
            this.needToShowModal = false
            this.$router.push('/')
            this.$notify({
              message: 'Произошла ошибка',
              type: 'danger'
            })
          })
      } else {
        api.post
          .createTask(taskInfo)
          .then(resp => {
            this.needToShowModal = false
            const createdTaskId = resp.data.data.task.id
            if (this.isFromCalculator) {
              this.clearCard()
            }
            this.updateTask(createdTaskId).then(() => {
              this.$router.push(`/view-task/${createdTaskId}`)
            })
          })
          .catch(() => {
            this.needToShowModal = false
            this.$router.push('/')
            this.$notify({
              message: 'Произошла ошибка',
              type: 'danger'
            })
          })
      }
    },
    cancelTask () {
      this.$router.push('/')
    },
    setClientFields (clientInfo) {
      this.clientId = clientInfo.id
      this.clientEmail = clientInfo.email
      this.clientPhone = clientInfo.phone
      this.clientDescription = clientInfo.clientDescription
    },
    setCompanyFields (companyInfo) {
      this.companyId = companyInfo.id
      this.companyEmail = companyInfo.email
      this.companyPhone = companyInfo.phone
    },
    clearClientFields () {
      // this.clientName = null
      this.clientEmail = null
      this.clientPhone = null
      this.clientDescription = null
    },
    clearCompanyFields () {
      // this.companyName = null
      this.companyEmail = null
      this.companyPhone = null
    },
    setFieldsFromTask (taskId) {
      const task = this.$store.state.tasks.find(function (task) {
        return task.id === taskId
      }, this)
      if (!task) this.$router.push('/')
      this.taskName = task.name
      this.isHot = task.hot
      this.clientId = task.client && task.client.id ? task.client.id : null
      this.companyId = task.client && task.client.legal_entity ? task.client.legal_entity.id : null

      if (this.companyId) {
        this.isActivePrivate = false
        this.isActiveCompany = true
      }

      this.taskDescription = task.description
      this.totalCost = task.price
      this.techMap = task.tech_map.map(x => {
        return { ...x, expanded: false }
      })
      this.techMapDesc = task.tech_map_desc
      if (this.isUpdate) {
        this.totalCost = task.price
        this.techMap = task.tech_map.map(x => {
          return { ...x, expanded: false }
        })
        this.techMapDesc = task.tech_map_desc
        this.deadlineDate = moment(task.end_time).format('DD-MM-YYYY')
        this.deadlineTime = moment(task.end_time).format('HH:mm')
        this.managerId = task.manager.user.id
      }
      this.autoExecution = task.auto_execution
      this.autoAlert = task.auto_alert
    },
    toggeleInfoMap () {
      this.isActiveInfoMap = true
      this.isActiveTechMap = false
    },
    toggeleTechMap () {
      this.isActiveInfoMap = false
      this.isActiveTechMap = true
    },
    toggelePrivate () {
      this.clientId = null
      this.clientName = ''
      this.companyId = null
      this.companyName = ''
      this.clearClientFields()
      this.clearCompanyFields()
      this.isActivePrivate = true
      this.isActiveCompany = false
    },
    toggeleCompany () {
      this.clientId = null
      this.clientName = ''
      this.companyId = null
      this.companyName = ''
      this.clearClientFields()
      this.clearCompanyFields()
      this.isActivePrivate = false
      this.isActiveCompany = true
    },
    deleteTechMapItem (id) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              this.techMap = this.techMap.filter(x => x.id !== id)
              this.totalCost = this.techMap.length > 0 ? this.techMap.map(x => +x.cost).reduce((a, b) => a + b).toFixed(2) : 0
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    addToTechMapFromBasket () {
      if (this.selectedBasketItem) {
        const selectedItem = this.$store.state.calculatedCard.find(x => x.id === this.selectedBasketItem)
        this.techMap.push({ ...selectedItem.data, id: selectedItem.id, expanded: false })
        this.taskName += ` +${selectedItem.data.name}`
        this.totalCost = this.techMap.map(x => +x.cost).reduce((a, b) => a + b).toFixed(2)
      }
      this.selectedBasketItem = null
      this.isAddFromBasketActive = false
    },
    closeAddFromBasket () {
      this.selectedBasketItem = null
      this.isAddFromBasketActive = false
    },
    checkPrice () {
      this.totalCost = this.totalCost.replace(',', '.')
    },
    ...mapActions({
      updateTask: 'UPDATE_TASK',
      clearCard: 'CLEAR_CARD',
      updateCard: 'UPDATE_CARD'
    })
  },
  computed: {
    managers () {
      const result = []
      const userForSelect = this.users.filter(
        x => x.roles === roles.director || x.roles === roles.manager
      )
      for (const user of userForSelect) {
        result.push({
          id: user.id,
          name: `${user.firstname} ${user.lastname}`
        })
      }
      return result
    },
    isCanDeleteTechItems () {
      return this.$store.getters.role === roles.director || this.$store.getters.role === roles.manager
    },
    clientNames () {
      if (this.isActivePrivate) {
        return this.clients.filter(x => !x.leid).map(x => { return { value: x.id, text: x.name, search: `${x.name}${x.email}${x.phone}`.replace(/[^a-zA-Zа-яА-Я0-9]+/g, '').toLowerCase() } })
      }

      if (this.isActiveCompany && !!this.companyId) {
        return this.clients.filter(x => x.leid === this.companyId).map(x => { return { value: x.id, text: x.name, search: `${x.name}${x.email}${x.phone}`.replace(/[^a-zA-Zа-яА-Я0-9]+/g, '').toLowerCase() } })
      }

      return []
    },
    companyNames () {
      return this.companies.map(x => { return { value: x.id, text: x.name, search: `${x.name}${x.email}${x.phone}`.replace(/[^a-zA-Zа-яА-Я0-9]+/g, '').toLowerCase() } })
    },
    deadLineDateTime () {
      return moment(
        `${this.deadlineDate} ${this.deadlineTime}`,
        'DD-MM-YYYY HH:mm'
      ).format()
    },
    isCanChangePrice () {
      return this.techMap.length === 0
    }
  },
  watch: {
    clientId: function (val) {
      const clientInfo = this.clients.find(x => x.id === val)
      if (clientInfo) {
        this.setClientFields(clientInfo)
        this.savedClientSelected = true
      } else {
        this.savedClientSelected = false
        this.clearClientFields()
      }
    },
    companyId: function (val) {
      const companyInfo = this.companies.find(x => x.id === val)
      if (companyInfo) {
        this.setCompanyFields(companyInfo)
        this.savedCompanySelected = true
      } else {
        this.savedCompanySelected = false
        this.clearCompanyFields()
      }
    }
  },
  async created () {
    this.managerId = this.$store.state.userInfo.id
    await Promise.all([this.loadUsers(), this.loadClients(), this.loadCompanies(), this.updateCard()])

    this.taskId && this.setFieldsFromTask(+this.taskId)
    if (this.isFromCalculator) {
      const selectedItems = this.$store.state.calculatedCard.filter(x => this.checkedCardItems.indexOf(x.id) >= 0)
      this.taskName = selectedItems.map(x => x.data.name).join(' + ')
      this.techMap = selectedItems.map(x => {
        return { ...x.data, id: x.id, expanded: false }
      })
      this.totalCost = this.techMap.map(x => +x.cost).reduce((a, b) => a + b).toFixed(2)
    }
  },
  beforeRouteLeave (to, from, next) {
    if ((this.taskDescription || this.taskName) && this.needToShowModal) {
      this.showModal = true
      this.showModal = this.onClickYesButton = () => {
        this.showModal = false
        next()
      }
      this.onClickNoButton = () => {
        this.showModal = false
      }
    } else {
      next()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let pageHeader = ''
      if (vm.isUpdate) {
        pageHeader = 'Редактирование задачи'
      } else if (vm.taskId) {
        pageHeader = 'Копирование задачи'
      } else {
        pageHeader = 'Создание задачи'
      }
      vm.$eventBus.$emit('pageHeaderChange', pageHeader)
    })
  }
}
